<template>
  <main class="main programmazione-siae max-width">
	  <article>
      <h1 class="title-medium">Programmazione SIAE</h1>

      <div v-if="user && user.id">
        <!--<div v-if="user.is_pro">-->
          <p>Vi preghiamo di compilare attentamente il programma sottostante. Questo ci consentirà di essere sempre aggiornati sulle vostre esecuzioni musicali e di venire incontro alle vostre esigenze. Tutti i campi sono obbligatori.</p>

          <form class="siae-form" @submit.prevent="submit">
            
            <div class="row row-1">
              <label for="gig" class="form-label" ref="gig"><span>Numero programma musicale</span></label>
              <input v-model="form.gig" type="number" name="gig" placeholder="Numero programma musicale">
              <div class="message" v-if="isInputEmpty.gig">Il numero del programma musicale è obbligatorio</div>
            </div>
            
            
            <div class="row row-1">
              <label for="club" class="form-label" ref="club"><span>Locale</span></label>
              <input v-model="form.club" type="text" name="club" placeholder="Locale">
              <div class="message" v-if="isInputEmpty.club">Il nome del locale è obbligatorio</div>
            </div>
            
            <div class="row row-1">
              <label for="place" class="form-label" ref="place"><span>Località</span></label>
              <input type="text" name="place" v-model="form.place" placeholder="Località" ref="place">
              <div class="message" v-if="isInputEmpty.place">Il nome della località è obbligatorio</div>
            </div>
            
            <div class="row row-1">
              <label for="date" class="form-label" ref="date"><span>Data</span></label>
              <input type="date" name="date" v-model="form.date" placeholder="Data">
              <div class="message" v-if="isInputEmpty.date">La data è obbligatoria</div>
            </div>
            
            <div class="row row-2">
              <div>
                <label for="surname" class="form-label" ref="surname"><span>Cognome</span></label>
                <input type="text" name="surname" placeholder="Cognome" v-model="form.surname" />
                <div class="message" v-if="isInputEmpty.surname">Il cognome è obbligatorio</div>
              </div>
              <div>
                <label for="name" class="form-label" ref="name"><span>Nome</span></label>
                <input type="text" name="name" placeholder="Nome" v-model="form.name" />
                <div class="message" v-if="isInputEmpty.name">Il nome è obbligatorio</div>
              </div>
            </div>

            <div class="row row-1">
              <label for="address" class="form-label" ref="address"><span>Indirizzo</span></label>
              <input type="text" name="address" placeholder="Indirizzo" v-model="form.address" />
              <div class="message" v-if="isInputEmpty.address">L'indirizzo è obbligatorio</div>
            </div>
            
            <div class="row row-1">
              <label for="city" class="form-label" ref="city"><span>Città</span></label>
              <input type="text" name="city" placeholder="Città" v-model="form.city" />
              <div class="message" v-if="isInputEmpty.city">La città è obbligatoria</div>
            </div>
            
            <div class="row row-2">
              <div>
                <label for="prov" class="form-label" ref="prov"><span>Provincia</span></label>
                <input type="text" name="prov" placeholder="Provincia" maxlength="255" v-model="form.prov" />
                <div class="message" v-if="isInputEmpty.prov">La provincia è obbligatoria</div>
              </div>
              <div>
                <label for="zip" class="form-label" ref="zip"><span>CAP</span></label>
                <input type="number" name="zip" placeholder="CAP"  maxlength="5" v-model="form.zip" />
                <div class="message" v-if="isInputEmpty.zip">Il CAP è obbligatorio</div>
              </div>
            </div>
            
            <div class="row row-1">
              <label for="email" class="form-label" ref="email"><span>Email</span></label>
              <input type="email" name="email" placeholder="Email" v-model="form.email" />
              <div class="message" v-if="isInputEmpty.email">L'email è obbligatoria</div>
            </div>
            
            <div class="row row-1">
              <label for="orchestra" class="form-label" ref="orchestra"><span>Orchestra</span></label>
              <input type="text" name="orchestra" placeholder="Orchestra" v-model="form.orchestra" />
              <div class="message" v-if="isInputEmpty.orchestra">L'orchestra è obbligatoria</div>
            </div>
            
            <div class="row row-1">
              <label for="instrument" class="form-label" ref="instrument"><span>Strumento suonato</span></label>
              <input type="text" name="instrument" placeholder="Strumento suonato" v-model="form.instrument" />
              <div class="message" v-if="isInputEmpty.instrument">Lo strumento è obbligatorio</div>
            </div>


            <report-entries @updateSongsFields="updateSongs" @update="updateSongs" @emptied="updateClearSongs" :isClearSongs="isClearSongs"></report-entries>

            <div class="row row-1">
              <label for="requests" class="form-label" ref="requests"><span>Eventuali richieste</span></label>
              <input type="textarea" name="requests" placeholder="Eventuali richieste" v-model="form.requests" >
            </div>

            <div class="checkboxes">
              <label class="control-checkbox" ref="privacy_consent">Accetto le <router-link to="privacy" target="_blank">condizioni</router-link> per la privacy
                <input type="checkbox" id="privacy_consent" v-model="form.privacy_consent" />
                <div class="control-indicator"></div>
              </label>
            </div>


            <input type="submit" id="programmazione-siae-submit" class="button button-big button-aqua button-anim" value="INVIA" :disabled="!form.privacy_consent || !AreAllSongsFieldsCorrectlyFilled">
          </form>

          <no-interaction-overlay 
            :isActive = "state && state == 'req-sent'"
            bgColor="azure"
            message="Stiamo inviando la programmazione. Per favore, attendi.."
          ></no-interaction-overlay>

          <snackbar 
            :states="states" 
            :state="state"
            :showSnackbar="showSnackbar"
            @close="showSnackbar = false"
          ></snackbar>
        </div>
        <!--<div v-else><p>Questa sezione è riservata ai professionisti! Esplora l'<router-link to="/catalog" class="green-link">archivio di Edizioni Caramba</router-link>.</p></div>-->
      </div>
      
      <div v-else>
        <p>Per inserire le tue programmazioni SIAE, e avere a disposizione tutti i contenuti speciali di Edizioni Caramba, effettua l'<router-link to="/login" class="green-link">accesso</router-link>, oppure <router-link to="/signup" class="green-link">registrati come nuovo utente!</router-link></p>
      </div>
    </article>
  </main>
</template>

<script>
import * as Cookies from 'js-cookie';
import axios from 'axios/dist/axios';
import ReportEntries from './ReportEntries.vue';
import Snackbar from './Snackbar.vue';
import NoInteractionOverlay from './NoInteractionOverlay.vue';
import scrollTo from './../utils/scroll-to.js';

export default {
  props: ['user'],

  data() {
    return {

      form : {
        gig: '',
        club: '',
        place: '',
        date: '',
        surname: '',
        name: '',
        address: '',
        city: '',
        prov: '',
        zip: '',
        email: '',
        orchestra: '',
        instrument: '',
        requests: '',
        privacy_consent: '',
      },

      isInputEmpty : {
        gig: false,
        club: false,
        place: false,
        date: false,
        surname: false,
        name: false,
        address: false,
        city: false,
        prov: false,
        zip: false,
        email: false,
        orchestra: false,
        instrument: false,
        requests: false,
        privacy_consent: false,
      },

      songs: [],



      states: [
        {name: 'success', message: 'La programmazione è stata inviata correttamente', bgColor: 'aqua'},
        {name: 'failure', message: 'Errore! Per favore, riprova.', bgColor: 'light_purple'}
      ],
      state: undefined,
      showSnackbar: false,

      isClearSongs: false,
      isGet: false
    }
  },

  computed: {

      AreAllSongsFieldsCorrectlyFilled : function() {

          var unfilledSongs = 0;
          this.songs.forEach((entity) => {
              if (entity.song == "" || entity.writer == "") unfilledSongs +=1;
          })

          return (unfilledSongs == 0);

      }

  },

  methods: {
    updateSongs: function(songs) {

      console.log("SONGS UPDATED", songs)

      this.songs = songs;
    },

    updateClearSongs: function() {
      this.isClearSongs = false;
    },

    submit: function() {
      const isValid = this.checkInputs();
      if(isValid) {
        this.state = 'req-sent';
        const token = Cookies.get('caramba-token');
        const headers = { 'Authorization': 'Bearer ' + token };
        const sendDataInstance = axios.create({headers});

        const data = JSON.parse(JSON.stringify(this.form));
        data.songs = this.songs;


        console.log(data);

        sendDataInstance.post('/api/v1/report/send', data)
          .then(resp => {
            this.state = 'success';
            this.showSnackbar = true;
            this.form.requests = '';
            this.form.gig = '';
            this.form.club = '';
            this.form.place = '';
            this.form.date = '';

            this.isClearSongs = true;
          })
          .catch(err => {
            this.state = 'failure';
            this.showSnackbar = true;
          });
      } else {
        // find the first available error
        const emptyFields = Object.keys(this.form).filter(key => this.isInputEmpty[key]);
        const targetY = this.$refs[emptyFields[0]].offsetTop - 200;
        scrollTo(targetY, 700, 'easeInOutQuint');     
      }
    },

    checkInputs() {
      this.isInputEmpty.gig = !this.isPresent(this.form.gig);
      this.isInputEmpty.club = !this.isPresent(this.form.club);
      this.isInputEmpty.place = !this.isPresent(this.form.place);
      this.isInputEmpty.date = !this.isPresent(this.form.date);
      this.isInputEmpty.surname = !this.isPresent(this.form.surname);
      this.isInputEmpty.name = !this.isPresent(this.form.name);
      this.isInputEmpty.address = !this.isPresent(this.form.address);
      this.isInputEmpty.city = !this.isPresent(this.form.city);
      this.isInputEmpty.prov = !this.isPresent(this.form.prov);
      this.isInputEmpty.zip = !this.isPresent(this.form.zip);
      this.isInputEmpty.email = !this.isPresent(this.form.email);
      this.isInputEmpty.orchestra = !this.isPresent(this.form.orchestra);
      this.isInputEmpty.instrument = !this.isPresent(this.form.instrument);
      this.isInputEmpty.privacy_consent = !this.isPresent(this.form.privacy_consent);

      return !Object.values(this.isInputEmpty).some(this.isTrue);
    },

    isTrue(el) {
      return el === true;
    },

    isPresent(data) {
      return data && data != '';
    },

    getUserInfo: function() {
      if(!this.isGet) {
        this.isGet = true;
        const token = Cookies.get('caramba-token');
        const headers = { 'Authorization': 'Bearer ' + token };
        const getUserInfoInstance = axios.create({headers});
        getUserInfoInstance.post('/api/v1/user/edit', {})
          .then(resp => {
            const d = resp.data;

            this.form.name = d.name != null ? d.name: '';
            this.form.surname = d.surname != null ? d.surname: '';
            this.form.address = d.address != null ? d.address: '';
            this.form.city = d.city != null ? d.city: '';
            this.form.prov = d.prov != null ? d.prov: '';
            this.form.zip = d.zip != null ? d.zip: '';
            this.form.email = d.email != null ? d.email: '';

            this.form.instrument = d.instrument != null ? d.instrument: '';
            this.form.orchestra = d.orchestra != null ? d.orchestra: '';
            
            this.isGet = false;
          })
          .catch(err => {
            this.isGet = false;
            this.$eventBus.$emit('user:logout', {goToLogin: true});
          });
      }
    }
  },

  watch: {
    user: function(newVal, oldVal) {
      if(newVal) {
        this.name = newVal.name;
        this.surname = newVal.surname;
        this.address = newVal.address;
        this.zip = newVal.zip;
        this.city = newVal.city;
        this.prov = newVal.prov;
        this.email = newVal.email;
        this.orchestra = newVal.orchestra;
        this.instrument = newVal.instrument;
      }
    }
  },

  components: {
    'report-entries': ReportEntries,
    'snackbar': Snackbar,
    'no-interaction-overlay': NoInteractionOverlay
  },

  mounted() {
    document.title = 'Caramba - Programmazione Siae';
    this.getUserInfo();
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';

.message {
  background: var(--aqua);
  padding: 2px 5px;
  font-size: 14px;
  display: inline-block;
  line-height: 14px;
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/vue/components/Report.vue